import * as React from 'react';

import { createIcon } from '../Icon';
export const CloudIcon = createIcon(
  <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />,
  'CloudIcon'
);
